var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    clipPath: "url(#clip0_522_2672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.193 4.50346C21.9323 3.51804 21.1643 2.74196 20.189 2.47858C18.4214 2 11.3333 2 11.3333 2C11.3333 2 4.2453 2 2.47761 2.47858C1.5024 2.742 0.734328 3.51804 0.473642 4.50346C0 6.28958 0 10.0162 0 10.0162C0 10.0162 0 13.7428 0.473642 15.5289C0.734328 16.5143 1.5024 17.258 2.47761 17.5214C4.2453 18 11.3333 18 11.3333 18C11.3333 18 18.4214 18 20.189 17.5214C21.1643 17.258 21.9323 16.5143 22.193 15.5289C22.6667 13.7428 22.6667 10.0162 22.6667 10.0162C22.6667 10.0162 22.6667 6.28958 22.193 4.50346ZM9.01513 13.3996V6.63271L14.9394 10.0163L9.01513 13.3996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6667,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7e64b03fbdcb43923b70782752af3d6f.svg";
export { ForwardRef as ReactComponent };